define('MM/Components/Forms/ValidationOptions',["jquery"], function ($) {
    "use strict";

    var instance = null;
    var defaultOptions = null;

    var initialize = function () {
        defaultOptions = {
            ignore: null,
            highlight: function (element, errorClass, validClass) {
                if (element.type === "radio") {
                    this.findByName(element.name).addClass(errorClass).removeClass(validClass);
                } else {
                    $(element).addClass(errorClass).removeClass(validClass);
                    $(element).closest(".form-group").removeClass("has-success").addClass("has-error");
                }
            },
            unhighlight: function (element, errorClass, validClass) {
                if (element.type === "radio") {
                    this.findByName(element.name).removeClass(errorClass).addClass(validClass);
                } else {
                    $(element).removeClass(errorClass).addClass(validClass);
                    $(element).closest(".form-group").removeClass("has-error");
                    if ($(element).val() || $(element).text()) {
                        $(element).closest(".form-group").addClass("has-success");
                    }
                    else if (!($(element).val() || $(element).text()) && $(element).closest(".form-group").hasClass("has-success")) {
                        $(element).closest(".form-group").removeClass("has-success");
                    }
                }
            },
            errorContainer: ".custom-summary-error"
        };
    };

    function ValidationOptions() {
        if (instance !== null) {
            throw console.log("Cannot instantiate more than one ValidationOptions, use ValidationOptions.getInstance()");
        }
        initialize();
    }

    ValidationOptions.getInstance = function () {
        if (instance === null) {
            instance = new ValidationOptions();
        }
        return instance;
    };

    ValidationOptions.prototype.getDefaultOptions = function () {
        return defaultOptions;
    };

    ValidationOptions.prototype.getUnobtrusiveOptions = function () {
        return {
            errorClass: "input-validation-error text-danger",
            validClass: "field-validation-valid"
        }
    };

    return ValidationOptions.getInstance();
});
